import React, { useState, useEffect, useRef } from "react";
import Constant from "../../../utils/constant";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import Loader from "../../shared/loader/loader";
import {
  AddIcon,
  EditIcon,
  CollapseDownIcon,
  CollapseUpIcon,
} from "../../../assets/icons/index";

import { connect } from "react-redux";
import {
  addFeedbackResolution,
  getFeedbackResolutionsStatuses,
  getLastUpdatedResolutions,
  getResolutionsByFeedbackId,
  updateFeedbackResolution,
} from "../../../api/feedback.service";
import moment from "moment";
import TeacherFeedbackUpdatePopup from "./teacherFeedbackUpdatePopup";
import { ISelectElement } from "../../../model/interface/keyValuePair";

export type IFeedbackResolutionsList = {
  feedbackId: number;
  feedbackResolutionId?: number;
  submittedByLastName?: string;
  submittedByFirstName?: string;
  submittedByEmail?: string;
  schoolName?: string;
  schoolCity?: string;
  questionId: number;
  contentAreaName?: string;
  feedbackComments?: string;
  referenceType?: string;
  feedbackSubmittedDate?: Date;
  feedbackStatusTypeId?: number;
  feedbackStatus?: string;
  resolutionComments?: string;
  resolvedByLastName?: string;
  resolvedByFirstName?: string;
  lastUpdated?: Date;
  reporterType?: number;
  isFeedbackResolutionExist?: boolean;
};
const TeacherFeedback = (props: any) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [statusUpdatePopup, setStatusUpdatePopup] = useState<boolean>(false);
  const [feedbackResolutions, setFeedbackResolutions] = useState<
    IFeedbackResolutionsList[]
  >([]);
  const [resolutions, setResolutions] = useState<IFeedbackResolutionsList[]>(
    []
  );
  const [feedbackStatuses, setFeedbackStatuses] = useState<ISelectElement[]>(
    []
  );
  const [orderByColumn, setOrderByColumn] = useState("name");
  const [totalPages, setTotalPages] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [sortByDesc, setSortByDesc] = useState<boolean>(true);
  const [toggle, setToggle] = useState<number>();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [popupAction, setPopupAction] = useState<string>("");
  const [feedbackResolutionId, setFeedbackResolutionId] = useState<
    number | undefined
  >(0);
  const [feedbackId, setFeedbackId] = useState<number | undefined>(0);
  const [statusId, setStatusId] = useState<number | undefined>(0);
  const [comment, setComment] = useState<string | undefined>("");
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);

  const handleFeedbackResolution = async (id, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      const response = getResolutionsByFeedbackId(id);
      const data = (await response).data;
      setResolutions(data);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setOrderByColumn(column);
  };

  const getFeedbacks = async () => {
    setToggle(undefined);
    setFeedbackResolutions([]);
    setLoading(true);
    const res = await getLastUpdatedResolutions(
      props.questionId,
      true,
      pageNumber,
      pageSize
    );
    if (res?.data?.data) {
      let feedbackCount = 0;
      res?.data?.data.forEach((feedback) => {
        if (feedback.feedbackStatus === "Open")
          feedbackCount = feedbackCount + 1;
      });
      props.updateQuestionFeedbackCount(feedbackCount);
      setFeedbackResolutions(res.data.data);
    }

    setTotalPages(Math.ceil(res?.data.totalRecords / pageSize));
    setLoading(false);
  };

  const getFeedbackStatuses = async () => {
    const res = await getFeedbackResolutionsStatuses();
    let statuses: ISelectElement[] = [];
    if (res.data.length > 0) {
      statuses = res?.data.map((element) => {
        return {
          value: element.id || 0,
          label: `${element.name}`,
        };
      });
    }
    setFeedbackStatuses(statuses);
  };

  const closeStatusUpdateModal = () => {
    setStatusUpdatePopup(false);
  };
  const showStatusUpdateModal = (
    action: string,
    feedback: IFeedbackResolutionsList
  ) => {
    setPopupAction(action);
    setFeedbackId(feedback.feedbackId);
    setFeedbackResolutionId(feedback.feedbackResolutionId);
    setStatusId(feedback.feedbackStatusTypeId);
    setComment(feedback.resolutionComments);
    setStatusUpdatePopup(true);
  };

  const statusUpdate = async (statusId: number, comment: string) => {
    setStatusUpdatePopup(false);
    if (popupAction == "Add") {
      const res = await addFeedbackResolution({
        feedbackId: feedbackId,
        feedbackStatusTypeId: statusId,
        resolutionComments: comment,
        userId: props.profile?.userId,
      });
      getFeedbacks();
    } else {
      const res = await updateFeedbackResolution({
        feedbackResolutionId: feedbackResolutionId,
        feedbackStatusTypeId: statusId,
        resolutionComments: comment,
        userId: props.profile?.userId,
      });
      getFeedbacks();
    }
  };

  useEffect(() => {
    getFeedbacks();
    getFeedbackStatuses();
  }, []);

  useEffect(() => {
    if (isLoaded) {
      getFeedbacks();
    }
    setToggle(undefined);
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      getFeedbacks();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
    setToggle(undefined);
  }, [pageSize]);

  return (
    <>
      {loading && <Loader />}

      {statusUpdatePopup && (
        <TeacherFeedbackUpdatePopup
          action={popupAction}
          closeStatusUpdateModal={closeStatusUpdateModal}
          statusUpdate={statusUpdate}
          feedbackResolutionId={feedbackResolutionId}
          statusId={statusId}
          comment={comment}
          feedbackStatuses={feedbackStatuses}
        />
      )}

      <div className="relative  py-1">
        <div id="dataContainer" className="mt-4">
          <div className="flex flex-col mt-1">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-primary-color">
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          <span className="flex gap-2">Id</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          <span className="flex gap-2">Teacher/Student</span>
                        </th>
                        <th
                          scope="col"
                          className="w-96 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          School
                        </th>
                        <th
                          scope="col"
                          className="w-96 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Content Area
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Text
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Category
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Date
                        </th>
                        <th
                          scope="col"
                          className="inline-flex items-center gap-2 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Comments
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Who Fixed?
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                        >
                          Updated On
                        </th>
                        <th
                          scope="col"
                          className="w-10 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {feedbackResolutions.map((feed, index) => (
                        <Disclosure key={index}>
                          {({ open }) => (
                            <>
                              <tr
                                key={index}
                                className={
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }
                              >
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500 relative">
                                  {/* <ActiveRowLine
                                        isActive={bundle.isActive}
                                      /> */}
                                  <div className="flex ...">
                                    <div className="mt-2">
                                      {feed?.isFeedbackResolutionExist ? (
                                        <DisclosureButton className="">
                                          {index !== toggle && (
                                            <CollapseDownIcon
                                              key={index}
                                              className={`w-5 h-5 text-gray-500`}
                                              onClick={(e) => {
                                                handleFeedbackResolution(
                                                  feed?.feedbackId,
                                                  index,
                                                  "show"
                                                );
                                              }}
                                            />
                                          )}

                                          {index === toggle && (
                                            <CollapseUpIcon
                                              key={index}
                                              className={`w-5 h-5 text-gray-500`}
                                              onClick={(e) => {
                                                handleFeedbackResolution(
                                                  feed?.feedbackId,
                                                  index,
                                                  "hide"
                                                );
                                              }}
                                            />
                                          )}
                                        </DisclosureButton>
                                      ) : (
                                        <DisclosureButton className="">
                                          {index !== toggle && (
                                            <CollapseDownIcon
                                              key={index}
                                              className={`w-5 h-5 text-purple-500 cursor-not-allowed`}
                                            />
                                          )}

                                          {index === toggle && (
                                            <CollapseUpIcon
                                              key={index}
                                              className={`w-5 h-5 text-purple-500 cursor-not-allowed`}
                                            />
                                          )}
                                        </DisclosureButton>
                                      )}
                                    </div>
                                    <div className="mt-2 ml-2">
                                      {feed.questionId}
                                    </div>
                                  </div>
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  <div>
                                    {feed.submittedByLastName +
                                      (feed.submittedByFirstName
                                        ? ", " + feed?.submittedByFirstName
                                        : "")}
                                    {feed.reporterType == 1 ? (
                                      <p
                                        className={`ml-2 inline-block bg-green-400 rounded-full text-xs shadow-sm py-0.5 px-3 `}
                                      >
                                        T
                                      </p>
                                    ) : (
                                      <p
                                        className={`ml-2 inline-block bg-yellow-400 rounded-full text-xs shadow-sm py-0.5 px-3 `}
                                      >
                                        S
                                      </p>
                                    )}
                                  </div>
                                </td>
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                  <p
                                    className={`inline-block bg-green rounded-full text-xs shadow-sm py-0.5 px-3 `}
                                  >
                                    {feed.schoolName +
                                      (feed.schoolCity
                                        ? ", " + feed.schoolCity
                                        : "")}
                                  </p>
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {feed.contentAreaName}
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {feed.feedbackComments}
                                </td>
                                <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {feed.referenceType}
                                </td>
                                <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {moment(feed.feedbackSubmittedDate).format(
                                    "MMMM DD,YYYY"
                                  )}
                                </td>
                                <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {feed.feedbackStatus}
                                </td>
                                <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {feed.resolutionComments}
                                </td>
                                <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {(feed.resolvedByLastName
                                    ? feed.resolvedByLastName
                                    : "") +
                                    (feed.resolvedByFirstName
                                      ? ", " + feed?.resolvedByFirstName
                                      : "")}
                                </td>
                                <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                  {moment(feed.lastUpdated).format(
                                    "MMMM DD,YYYY"
                                  )}
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                  <div className="flex gap-3 justify-center">
                                    <AddIcon
                                      onClick={() =>
                                        showStatusUpdateModal("Add", feed)
                                      }
                                      className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                    />
                                    <EditIcon
                                      onClick={() =>
                                        showStatusUpdateModal("Edit", feed)
                                      }
                                      className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={10} className="relative ">
                                  <div
                                    className={`${
                                      index !== toggle ? "hidden" : ""
                                    } pl-12 pr-12 px-4 pb-2 text-sm text-gray-500`}
                                  >
                                    {/* <ActiveRowLine isActive={bundle.isActive} /> */}
                                    <div className="shadow border-b rounded">
                                      <table className="min-w-full">
                                        <thead>
                                          <tr className="bg-gray-50 border">
                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 text-xs text-left text-gray-500 font-semibold tracking-wider"
                                            >
                                              <div className="flex items-center">
                                                <span className="flex gap-2">
                                                  Status
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              scope="col"
                                              className="gap-2 px-3 py-2 pl-6 font-semibold text-xs text-left text-gray-500 tracking-wider"
                                            >
                                              <div className="flex items-center">
                                                <span className="flex gap-2">
                                                  Comments
                                                </span>
                                              </div>
                                            </th>

                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 text-xs text-left text-gray-500 font-semibold tracking-wider"
                                            >
                                              <div className="flex items-center">
                                                <span className="flex gap-2">
                                                  Updated By
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 text-xs text-left text-gray-500 font-semibold tracking-wider"
                                            >
                                              <div className="flex items-center">
                                                <span className="flex gap-2">
                                                  Updated On
                                                </span>
                                              </div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="divide-y">
                                          {resolutions?.map(
                                            (resolution, index) => (
                                              <tr
                                                key={index}
                                                className={"bg-white"}
                                              >
                                                <td>
                                                  {resolution.feedbackStatus}
                                                </td>
                                                <td>
                                                  {
                                                    resolution.resolutionComments
                                                  }
                                                </td>

                                                <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                  {(resolution.resolvedByLastName
                                                    ? resolution.resolvedByLastName
                                                    : "") +
                                                    (resolution.resolvedByFirstName
                                                      ? ", " +
                                                        resolution?.resolvedByFirstName
                                                      : "")}
                                                </td>
                                                <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                  {moment(
                                                    resolution.lastUpdated
                                                  ).format("MMMM DD,YYYY")}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                    {resolutions?.length === 0 && (
                                      <p className="p-2">No product added</p>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                        </Disclosure>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center">
              {feedbackResolutions.length !== 0 ? (
                <>
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                    />
                  </span>
                </>
              ) : (
                <p className="p-2">No Records Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(TeacherFeedback);
